import forgotpassword from 'api/definitions/forgotpassword';
import { appendClientIdParamWhenInWebview } from 'utils/append-client-id-param-when-in-webview';
import history from 'utils/history';
import urls from 'constants/urls';

import { postForgotPasswordActionTypes } from './types';

const forgotPasswordAsync = email => ({
  types: postForgotPasswordActionTypes.triplet,
  apiCall: forgotpassword.post({ body: { username: email } }),
  email,
});

export const forgotPassword = values => async dispatch =>
  dispatch(forgotPasswordAsync(values.email)).then(() => {
    history.push(appendClientIdParamWhenInWebview(urls.forgotPasswordSuccess));
  });
